export default (sortBy, rowsPerPage, direction) => {
	return {
		rowsPerPage: rowsPerPage ? rowsPerPage : 25,
		page: 1,
		sortBy: [...sortBy],
		sortDesc: direction ? direction : [],
	}
}
